module.exports = __webpack_public_path__ + "2f6ef0514130572770e2aa6caf235da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/senior_report/assets/A@2x.png
// module id = 804
// module chunks = 0